var _rect, _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 314,
    height: 76,
    viewBox: "0 0 314 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 66,
    rx: 16,
    transform: "translate(14 10)",
    fill: "#fcee21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 66,
    rx: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 295,
    height: 61,
    rx: 13.5,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(150 43)",
    fontSize: 24,
    fontFamily: "MicrosoftJhengHeiBold, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -72,
    y: 0
  }, "\u99AC\u4E0A\u7D2F\u7A4D\u9EDE\u6578"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescript);
export default __webpack_public_path__ + "static/media/descript.d19d574770f103f5a1b0efc31a5015a9.svg";
export { ForwardRef as ReactComponent };